/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./airdropReward.vue?vue&type=template&id=6a2d099e&scoped=true"
import script from "./airdropReward.vue?vue&type=script&lang=js"
export * from "./airdropReward.vue?vue&type=script&lang=js"
import style0 from "./airdropReward.vue?vue&type=style&index=0&id=6a2d099e&prod&lang=scss"
import style1 from "./airdropReward.vue?vue&type=style&index=1&id=6a2d099e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2d099e",
  null
  
)

export default component.exports